import { laborHoursConstant } from 'src/redux/actions/constant';

// Keyed by labourManagementId: several rows can be expanded at once, so each one
// needs its own loading / response slot rather than a single shared `response`.
const intitialstate: any = {
  byId: {},
};

const patchEntry = (state: any, id: string, patch: any) => ({
  ...state,
  byId: {
    ...state.byId,
    [id]: { ...(state.byId?.[id] || {}), ...patch },
  },
});

export const getLaborEntryHistoryReducer = (state = intitialstate, action: any) => {
  const id = action?.payload?.labourManagementId;

  switch (action.type) {
    case laborHoursConstant.GET_LABOR_ENTRY_HISTORY_LOADER:
      if (!id) return state;
      return patchEntry(state, id, { loading: true, isError: false });

    case laborHoursConstant.GET_LABOR_ENTRY_HISTORY_SUCCESS:
      if (!id) return state;
      return patchEntry(state, id, {
        loading: false,
        isError: false,
        response: action.payload?.data?.data,
      });

    case laborHoursConstant.GET_LABOR_ENTRY_HISTORY_FAILURE:
      if (!id) return state;
      return patchEntry(state, id, {
        loading: false,
        isError: true,
        response: action.payload?.error,
      });

    case laborHoursConstant.GET_LABOR_ENTRY_HISTORY_RESET:
      return intitialstate;

    default:
      return state;
  }
};
